import { ConfigProvider, Spin } from 'antd';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import ContentContainer from './components/ContentContainter/ContentContainer.jsx';
import { wsGetAlmatyPolygons } from './utils/webSocketConfig.js';
import {
  $loader,
  $webSocketConnected,
  initPublicSocketEv,
} from './models/webSocketModel/index.js';
import {
  $authStatus,
  $isDarkTheme,
  $userList,
  getUserListFx,
  setAuthStatusEv,
} from './models/authModel/index.js';
import { cookies } from './api/axiosinstance.js';
import { darkTheme, lightTheme } from './themeConfigs/themeConfigs.js';
import { $zoom10Hexagons } from './models/zoom10Model/index.js';
import { getDataPresetsFx } from './models/dataPresetsModel/index.js';
import { getZeroDataFx } from './models/zoom7Model/index.js';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const webSocketConnected = useUnit($webSocketConnected);
  const showLoader = useUnit($loader);
  const authStatus = useUnit($authStatus);
  const setAuth = useUnit(setAuthStatusEv);
  const isDarkTheme = useUnit($isDarkTheme);
  const zoom10Hexagons = useUnit($zoom10Hexagons);
  const getUserList = useUnit(getUserListFx);
  const userList = useUnit($userList);
  const initPublicSocket = useUnit(initPublicSocketEv);

  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/root');
    }
  }, [location]);

  const safeSend = () => {
    if (window.ws.readyState === 1) {
      wsGetAlmatyPolygons();
    } else {
      setTimeout(() => {
        safeSend();
      }, 100);
    }
  };

  useEffect(() => {
    if (webSocketConnected) {
      if (
        zoom10Hexagons.length === 0 &&
        (location.pathname.includes('root') ||
          location.pathname === '/map-public')
      ) {
        safeSend();
        window.download_start = performance.now();
      }
      if (location.pathname === '/user-list' && userList.length === 0) {
        getUserList();
      }
      // console.time('TIME:: zoom 8 polygons_v2');
      // console.time('TIME:: zoom 9 polygons_v2');
      // console.time('TIME:: download zoom 10 polygons');
      // wsGetAlmatyPolygonsV2();
    }
  }, [webSocketConnected, zoom10Hexagons, location]);

  useEffect(() => {
    if (
      !authStatus &&
      location.pathname !== '/chat-modal' &&
      location.pathname !== '/map-public'
    ) {
      const token = cookies.get('access_token');
      if (!token) {
        navigate('/login');
      } else {
        setAuth(true);
      }
    }
  }, [authStatus, location]);

  useEffect(() => {
    if (window.location.pathname === '/map-public') {
      initPublicSocket();
    }
  }, []);
  const antdDark = location.pathname === '/map-public' || isDarkTheme;

  return (
    <ConfigProvider theme={antdDark ? darkTheme : lightTheme}>
      <Spin spinning={showLoader} tip="Загружаем данные..." size="large">
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </Spin>
    </ConfigProvider>
  );
}

export default App;

// FIXME Rebuild commmit
